import React, { FC, memo } from 'react';
import { FormControl, FormGroup, FormLabel } from 'react-bootstrap';
import cls from './TariffStripeSettings.module.scss';

type TariffStripeSettingsProps = {
  stripeProductIdValue?: string;
  stripeProductIdError?: string;
  stripePriceIdValue?: string;
  stripePriceIdError?: string;
  onChange: (event: React.ChangeEvent) => void;
};

const TariffStripeSettings: FC<TariffStripeSettingsProps> = memo((props) => {
  const {
    stripeProductIdValue,
    stripeProductIdError,
    stripePriceIdValue,
    stripePriceIdError,
    onChange,
  } = props;

  return (
    <div className={cls.Container} data-testid="tariff-stripe-settings">
      <h4 className="title-4">Stripe</h4>
      <p className={cls.Hint}>
        The ids come from Stripe itself. A subscription tariff cannot be activated until both are
        filled in; clear them to unbind the tariff from Stripe.
      </p>
      <FormGroup className="position-relative">
        <FormLabel htmlFor="stripeProductId" className="input-title-text">
          Product ID
        </FormLabel>
        <FormControl
          type="text"
          name="stripeProductId"
          id="stripeProductId"
          placeholder="prod_..."
          value={stripeProductIdValue ?? ''}
          isInvalid={!!stripeProductIdError}
          onChange={onChange}
        />
        <FormControl.Feedback type="invalid" tooltip>
          {stripeProductIdError}
        </FormControl.Feedback>
      </FormGroup>
      <FormGroup className="position-relative">
        <FormLabel htmlFor="stripePriceId" className="input-title-text">
          Price ID
        </FormLabel>
        <FormControl
          type="text"
          name="stripePriceId"
          id="stripePriceId"
          placeholder="price_..."
          value={stripePriceIdValue ?? ''}
          isInvalid={!!stripePriceIdError}
          onChange={onChange}
        />
        <FormControl.Feedback type="invalid" tooltip>
          {stripePriceIdError}
        </FormControl.Feedback>
      </FormGroup>
    </div>
  );
});

export default TariffStripeSettings;
